<div fxLayout="column" class="neq-dialog">
    <div *ngIf="message" class="message" innerText="{{ message | translate }}">
    </div>

    <div class="asi-container" fxLayout="row" fxLayoutAlign="center center">
      <button pButton class="neq-primeng-button-text" label="{{'msg.common.validation.ok' | translate}}" (click)="continue()"></button>
    </div>
</div>
